import Ratings from '@dynamic-components/sections/Ratings'

import { config } from './config'

export function DevOpsExpertiseSection() {
  return <Ratings {...config} />
}
